module.exports = __webpack_public_path__ + "media/images/pepsi_home/palm_tree_icon-f6801e962f9667f7cae9447357810982.png";